var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 62,
    viewBox: "0 0 62 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.459 61.02V21.357H0L30.51 0L61.02 21.357H33.561V61.02H27.459ZM3.051 61.02V45.0023L0.6102 31.5779L6.55965 30.51L8.8479 42.714H21.357V61.02H15.255V48.816H9.153V61.02H3.051ZM39.663 61.02V42.714H52.1721L54.4604 30.51L60.4098 31.5779L57.969 45.0023V61.02H51.867V48.816H45.765V61.02H39.663ZM19.3739 15.255H41.6462L30.51 7.47495L19.3739 15.255Z",
    fill: "#1C1B1F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeck);
export default __webpack_public_path__ + "static/media/deck.658106a0a68dcf84f215fab93e265a8c.svg";
export { ForwardRef as ReactComponent };